export default {"src":"/_next/static/media/electricity.c3e0db67.svg","height":300,"width":300};